import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { AdminService } from 'src/app/admin/admin.service';
import { PublicServiceService } from 'src/app/public-service.service';
import { OwlOptionsConfig } from 'src/app/utils/Carousel-config';
import { getLanguages } from 'src/environments/environment';

@Component({
  selector: 'app-home-donor',
  standalone: true,
  imports: [CarouselModule, CommonModule],
  templateUrl: './home-donor.component.html',
  styleUrl: './home-donor.component.scss'
})
export class HomeDonorComponent {
    partnerSlides: OwlOptions = OwlOptionsConfig
    donors: any
	imageUrl

  constructor(private publicService: PublicServiceService, private adminService: AdminService,
  ) {
    this.imageUrl = this.publicService.IMAGE_URL
    if (Number(localStorage.getItem("language")) == getLanguages().FA_IR) {
      this.partnerSlides["rtl"] = true
    }

  }

  ngOnInit(): void {

    this.getDonors()
  }

	
  getDonors() {
    this.publicService.getRecordHome(this.adminService.DONOR_URL).subscribe({
      next: (res) => {
        this.donors = res

      },
      error: (error) => {
        console.error("here goes the Unexpected error:", error);
      }
    })
  }


}
